import { useLocalSearchParams } from 'expo-router'
import { PropertyView } from '~/components/assets/PropertyView'
import ScreenView from '~/components/layout/ScreenView'

export default function PropertyDetails() {
  const { assetId } = useLocalSearchParams<{ assetId: string }>()

  return (
    <ScreenView className="flex-1" innerClassName="flex-1">
      <PropertyView assetId={assetId} className="flex-initial" />
    </ScreenView>
  )
}
